import React, { useRef, useCallback, useEffect, useState, useContext } from 'react';
import { useFocusable, FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { getAssetByID, getUpcomingRailAssets } from '../../API/api';
import { utility } from '../../utility/utilityProvider';
import { DISPLAYPLATFORM, LOCALSTORAGE_KEY, RAILTYPE } from '../../constant/constant';
import { PlatformContext } from '../../../Contexts/PlatformContext';
import RailImageCard from './RailImageCard';

const RailComponent = (props) => {

    const { onFocus, rowIndex, railType, setOttAsset, isMobile, ottSetting } = props;
    const { ref, focusKey, getCurrentFocusKey } = useFocusable({
        trackChildren: true,
        focusable: isMobile ? false : true,
        onFocus: onFocus,
    });
    const MediaCarouselRef = useRef(null);
    const [rail, setRail] = useState(props.rail);
    const [isMouseHover, setIsMouseHover] = useState(false);

    const displayPlatform = useContext(PlatformContext);
    const isWeb = displayPlatform === DISPLAYPLATFORM.WEB;

    useEffect(() => {
        setRail(props.rail);
        if (railType == RAILTYPE.UpcomingRail || railType == RAILTYPE.UpcomingPage) {
            getUpcomingRail();
        }
    }, [props.rail]);

    const getUpcomingRail = async () => {
        let res = await getUpcomingRailAssets();
        if (res.success) {
            setRail({ ...rail, OttAsset: res.data });
        }
    }

    const onCardFocus = useCallback(({ x, asset, node, ...rest }) => {
        setCurrentOttAsset(asset);
        if (!isMobile) {
            node.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }

    }, [MediaCarouselRef]);

    const setCurrentOttAsset = async (asset) => {

        const ottAssetRes = await getAssetByID(asset._id);
        if (ottAssetRes.success) {
            console.log(ottAssetRes);
            setOttAsset(ottAssetRes.data);
        } else {
            setOttAsset(asset);
        }

    }

    let fontWeight = ottSetting?.themeData?.rail?.fontWeight;

    const isRightToLeft = utility.getValue(LOCALSTORAGE_KEY.language)?.isRightToLeft ?? false;
    
    return (
        <FocusContext.Provider value={focusKey}>

            <div ref={ref} className="railContainer" onMouseEnter={() => setIsMouseHover(true)} onMouseLeave={() => setIsMouseHover(false)} style={{ position: "relative", }}>

                <div className="m-2 textColor">
                    <p style={{ fontWeight: fontWeight < 4 ? "lighter" : fontWeight < 6 ? "normal" : fontWeight < 8 ? "bold" : "bolder", color: ottSetting?.themeData?.rail?.color ?? "white", fontFamily: ottSetting?.themeData?.rail?.fontFamily ?? "Roboto", fontSize: "12px", marginBottom: 0, textAlign: isRightToLeft ? "end" : "start" }}>{rail.DisplayTitle}</p>
                </div>

                <div className="ContentRowScrollingWrapper" ref={MediaCarouselRef} style={{ direction: isRightToLeft ? 'rtl' : 'ltr' }}>
                    <div className='ContentRowScrollingContent' style={{ display: 'flex', flexDirection: 'row', overflowX: 'auto', width: "100%", maxWidth: '54vw', scrollbarWidth: "none" }}>
                        {isWeb && <>
                            <div onClick={() => {
                                MediaCarouselRef.current.scrollTo({ left: MediaCarouselRef.current.scrollLeft - 300, behavior: 'smooth' });
                            }} style={{ color: "white", position: "absolute", top: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center", zIndex: "1", cursor: "pointer", padding: "0px 20px", backgroundImage: "linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0.7), rgba(0,0,0,0.5),rgba(0,0,0,0.3),rgba(0,0,0,0))", opacity: isMouseHover ? 1 : 0, transition: "opacity 0.3s ease-in-out" }}><i className='fa fa-angle-left fa-lg' /></div>
                            <div onClick={() => {
                                MediaCarouselRef.current.scrollTo({ left: MediaCarouselRef.current.scrollLeft + 300, behavior: 'smooth' });
                            }} style={{ color: "white", position: "absolute", top: 0, bottom: 0, right: 0, display: "flex", justifyContent: "center", alignItems: "center", zIndex: "1", cursor: "pointer", padding: "0px 20px", backgroundImage: "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0.7), rgba(0,0,0,0.5),rgba(0,0,0,0.3),rgba(0,0,0,0))", opacity: isMouseHover ? 1 : 0, transition: "opacity 0.3s ease-in-out" }}><i className='fa fa-angle-right fa-lg' /></div>
                        </>
                        }
                        {
                            rail.OttAsset.map((asset, index) => {
                                return (<FocusContext.Provider value={focusKey}>
                                    {/* <div key={index} style={{ color: "black" }}>
                                    .
                                    </div> */}
                                    <RailImageCard
                                        railType={railType}
                                        key={"img-" + index}
                                        index={index}
                                        asset={asset}
                                        onFocus={(props) => onCardFocus({ ...props, asset })}
                                        CustomeFocusKey={rail?.SID + "-" + index + "-" + rowIndex}
                                        ottSetting={ottSetting}
                                        theme={ottSetting?.themeData}
                                        isMobile={isMobile}

                                    />
                                </FocusContext.Provider>)
                            })}
                    </div>
                </div>
            </div >
        </FocusContext.Provider >
    )
}

export default RailComponent